/**
 * Helpers for detecting when the Jedi API (NEXT_PUBLIC_API_URL) is unreachable
 * or returning gateway errors — e.g. during deploys.
 */

/** Thrown when the maintenance overlay is blocking API traffic — avoids toast/retry storms. */
export class BackendUnavailableError extends Error {
  constructor() {
    super('Backend temporarily unavailable');
    this.name = 'BackendUnavailableError';
  }
}

export function isBackendUnavailableError(e: unknown): e is BackendUnavailableError {
  return e instanceof BackendUnavailableError;
}

const rawBase = process.env.NEXT_PUBLIC_API_URL?.trim() ?? '';
const normalizedBase = rawBase.replace(/\/$/, '');

export function getApiBaseUrl(): string {
  return normalizedBase;
}

export function isApiRequestUrl(url: string): boolean {
  if (!normalizedBase) return false;
  return url.startsWith(normalizedBase);
}

/**
 * Public health check under the same base path as the rest of the API.
 * Used to detect when the service is back after a deploy without requiring auth.
 */
export function getBackendAvailabilityPingUrl(): string | null {
  if (!normalizedBase) return null;
  return `${normalizedBase}/health`;
}
